module.exports = __webpack_public_path__ + "media/images/guide-8-f4c284307c0e52c2cf3922933e1ad83c.png";